import { render, staticRenderFns } from "./EditSchoolGatherPlace.vue?vue&type=template&id=971cd344&scoped=true&"
import script from "./EditSchoolGatherPlace.vue?vue&type=script&lang=js&"
export * from "./EditSchoolGatherPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971cd344",
  null
  
)

export default component.exports